// src/components/PageHeader.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../styles/PageHeader.module.css';

const PageHeader = ({ titleKey, descriptionKey, breadcrumbsKey, title, description, breadcrumbs }) => {
  const { t } = useTranslation();

  // 支持两种使用方式：
  // 1. 传入翻译键 (titleKey, descriptionKey, breadcrumbsKey)
  // 2. 传入直接文本 (title, description, breadcrumbs) - 向后兼容
  const displayTitle = titleKey ? t(titleKey) : title;
  const displayDescription = descriptionKey ? t(descriptionKey) : description;
  
  // 处理面包屑导航 - 添加安全检查
  let displayBreadcrumbs;
  if (breadcrumbsKey) {
    try {
      const translatedBreadcrumbs = t(breadcrumbsKey, { returnObjects: true });
      // 确保返回的是数组
      displayBreadcrumbs = Array.isArray(translatedBreadcrumbs) ? translatedBreadcrumbs : breadcrumbs || [];
    } catch (error) {
      console.warn('Failed to translate breadcrumbs:', error);
      displayBreadcrumbs = breadcrumbs || [];
    }
  } else {
    displayBreadcrumbs = breadcrumbs || [];
  }

  return (
    <section className={styles.pageHeader}>
      <div className={styles.container}>
        <div className={styles.breadcrumb}>
          {displayBreadcrumbs && Array.isArray(displayBreadcrumbs) && displayBreadcrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              {crumb.path ? (
                <Link to={crumb.path}>{crumb.label}</Link>
              ) : (
                <span className={styles.current}>{crumb.label}</span>
              )}
              {index < displayBreadcrumbs.length - 1 && <i className="fas fa-chevron-right"></i>}
            </React.Fragment>
          ))}
        </div>
        <h1>{displayTitle}</h1>
        <p>{displayDescription}</p>
      </div>
    </section>
  );
};

export default PageHeader;